import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Toasted from 'vue-toasted'
import i18n from './i18n'
import Echo from 'laravel-echo'

Vue.use(require('vue-shortkey'))
Vue.use(Toasted, {
  theme: 'toasted-primary',
  duration: 5000,
  position: 'bottom-right',
  action: {
    text: i18n.t('labels.fechar'),
    onClick: (e, toastObject) => {
      toastObject.goAway(0)
    },
    class: 'white--text',
  },
})

Vue.config.productionTip = false

window.Pusher = require('pusher-js')

window.Echo = new Echo({
  broadcaster: 'pusher',
  key: process.env.VUE_APP_WEBSOCKETS_KEY,
  cluster: process.env.PUSHER_APP_CLUSTER,
  wsHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
  wsPort: process.env.VUE_APP_WEBSOCKETS_PORT,
  forceTLS: false, // produção = true -- dev  =false
  disableStats: true, // true para não enviar estatisticas para o servidor pusher
})
// Check that service workers are supported
if ('serviceWorker' in navigator && process.env == 'production') {
  // Use the window load event to keep the page load performant
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
  })
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
